import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
import { MenuStylingModel } from '../menu/menu-styling.model';
export class InputStylingModel extends CoreStylingModel {

  iconStyling: IconStylingModel;

  menuStyling: MenuStylingModel;

  input: StylingModel;

  hint: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);

    if (this.input == null) { this.input = new StylingModel(); }

    if (this.hint == null) { this.hint = new StylingModel(); }

    if (this.iconStyling == null) { this.iconStyling = new IconStylingModel(); }

    if (this.menuStyling == null) { this.menuStyling = new MenuStylingModel(); }
  }
}

function InputStylingModel_tsickle_Closure_declarations() {
/** @type {?} */
InputStylingModel.prototype.iconStyling;
/** @type {?} */
InputStylingModel.prototype.menuStyling;
/** @type {?} */
InputStylingModel.prototype.input;
/** @type {?} */
InputStylingModel.prototype.hint;
}

